/** @format */

import {safeDivide} from 'helpers/numberHelpers';

export const ratioPercent = (dividend: number, divisor: number): number =>
  safeDivide(dividend, divisor) * 100;
